import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useAuditLogsProjectGroupsItemSheet } from "@/libs/react-query/hooks/useItemsheetsQuery";
import { useParams } from "react-router-dom";
import { useSelectedProjectInfo } from "../hooks/useTabStore";
import { ProjectType } from "@/consts/Project";
import { History } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { formatDate } from "@/libs/utils";
import { actionTextMap } from "../utils";

export default function EstimateAuditLogsDialog() {
  const { group_id = "" } = useParams();
  const selectedProjectInfo = useSelectedProjectInfo();

  const { data } = useAuditLogsProjectGroupsItemSheet(group_id, {
    project_id: selectedProjectInfo?.projectId ?? "",
    project_type: selectedProjectInfo?.projectType ?? ProjectType.PROJ,
  });
  const { audit_logs = [] } = data || {};

  return (
    <Dialog>
      <DialogTrigger asChild>
        <div className="w-fit cursor-pointer">
          <History size={24} className="text-dark-red" />
        </div>
      </DialogTrigger>
      <DialogContent className="w-[640px] max-h-[413px] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl text-gray-A font-bold">
            산출내역서 수정 로그
          </DialogTitle>
          <DialogDescription className="text-xs text-gray-B font-normal" />
        </DialogHeader>
        <div className="flex flex-col gap-2">
          {audit_logs?.map((log) => (
            <div
              key={log.id}
              className="flex items-center gap-2 p-2 border-b border-gray-D last:border-none"
            >
              <Avatar className="size-6">
                <AvatarImage src={log.user_info.img_url} />
                <AvatarFallback>
                  {log.user_info.user_name.charAt(0)}
                </AvatarFallback>
              </Avatar>
              <div className="flex-1 flex items-center justify-between">
                <div className="flex gap-2 text-xs text-gray-A font-normal">
                  <span className="shrink-0 font-semibold">
                    {log.user_info.user_name}
                  </span>
                  <div className="break-words">
                    {`${log.itemsheet_latest_title}을 ${actionTextMap[log.action]} 하였습니다`}
                  </div>
                </div>
                <span className="shrink-0 text-[10px] text-gray-B font-semibold">
                  {formatDate(log.created_at, "yyyy년 M월 d일 a h:mm")}
                </span>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
